import type { Options } from "ky";

import { postJson } from "#app/lib/fetchClient";

import { GATEWAY_PATHS, urlSearchParamsToString } from "../api-utils";
import type { AuthVendorLoginResponse } from "./model-types";

type PostAuthVendorAuthorizeParams = {
  AuthVendorJwt?: string | null | undefined;
  outageBypasscode?: string;
};

type PostAuthVendorAuthorizeData = AuthVendorLoginResponse;

export async function postAuthVendorAuthorize(
  params: PostAuthVendorAuthorizeParams & Pick<Options, "signal">,
): Promise<PostAuthVendorAuthorizeData> {
  // Parse incoming
  const searchParams = parseAuthVendorParams(params);

  // Call endpoint
  const data = await postJson<PostAuthVendorAuthorizeData>(
    `${GATEWAY_PATHS.bolAuthenticationService}/Authorize/User/NewToken${searchParams}`,
    {
      // Restore for RefreshToken credentials: "include",
      headers: { AuthVendorJwt: params.AuthVendorJwt ?? "" },
      json: {},
      signal: params.signal,
    },
    true,
  );

  // Success
  return data;
}

function parseAuthVendorParams(params: PostAuthVendorAuthorizeParams) {
  // Destructure params
  const { outageBypasscode } = params;

  // Build urlSearchParams
  const urlSearchParams = new URLSearchParams();

  if (outageBypasscode) {
    urlSearchParams.set("outageBypasscode", outageBypasscode);
  }

  // Create searchParams string
  const searchParams = urlSearchParamsToString(urlSearchParams);

  return searchParams;
}
